import { createSlice } from '@reduxjs/toolkit'
import { gameClose, userLogin } from 'redux-store/thunk/auth.thunk'
import { fetchUserInformation } from 'redux-store/thunk/user.thunk'
import { getPayloadFromToken } from 'helpers/common.helpers'
import { plus, minus } from 'number-precision'
import { CURRENCY_SYMBOLS, IFRAME_MESSAGE_EVENTS } from 'utils/constants/index'
import { sendMessageOutsideIframe } from 'utils/game.utils'

const defaultAuthState = {
  creditWalletWaitQueue: [],
  creditDemoWalletWaitQueue: [],
  userInfo: null,
  userDetails: null,
  currencyId: null,
  currencyCode: null,
  isLoggedIn: false,
  showName: false
}

const authSlice = createSlice({
  name: 'authSlice',
  initialState: defaultAuthState,
  reducers: {
    appendCreditWalletWaitQueue: (state, action) => {
      return {
        ...state,
        creditWalletWaitQueue: [action.payload, ...state.creditWalletWaitQueue]
      }
    },
    updatePlinkoCreditWalletWaitQueue: (state, action) => {
      const { currentBetWinningAmount } = action.payload

      const currentBalance = state.userInfo.wallet.balance ?? 0
      const updatedBalance = Math.max(plus(currentBalance, +currentBetWinningAmount), 0)

      // const { currency } = state.userInfo.wallet
      // sendMessageOutsideIframe(IFRAME_MESSAGE_EVENTS.BALANCE_UPDATED, { type: 'credit', balance: updatedBalance, currency })

      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          wallet: {
            ...state.userInfo.wallet,
            balance: updatedBalance
          }
        }
      }
    },

    updateCreditWalletWaitQueue: (state, action) => {
      let _creditWalletWaitQueue = [...state.creditWalletWaitQueue]
      const _userInfoWallet = _creditWalletWaitQueue[0] ?? state.userInfo.wallet
      _creditWalletWaitQueue = _creditWalletWaitQueue?.slice(0, _creditWalletWaitQueue.length - 1)
      let { balance, currency } = _userInfoWallet
      balance = balance > 0 ? balance : 0
      sendMessageOutsideIframe(IFRAME_MESSAGE_EVENTS.BALANCE_UPDATED, { type: 'credit', balance, currency })
      return {
        ...state,
        creditWalletWaitQueue: _creditWalletWaitQueue,
        userInfo: {
          ...state.userInfo,
          wallet: _userInfoWallet
        }
      }
    },
    updateCreditDemoWalletWaitQueue: (state, action) => {
      let _creditDemoWalletWaitQueue = [...state.creditDemoWalletWaitQueue]
      const _newDemoWallet = _creditDemoWalletWaitQueue.pop() ?? state.demoWallet
      _creditDemoWalletWaitQueue = _creditDemoWalletWaitQueue?.slice(0, _creditDemoWalletWaitQueue.length - 1)
      return {
        ...state,
        creditDemoWalletWaitQueue: _creditDemoWalletWaitQueue,
        demoWallet: _newDemoWallet
      }
    },
    appendCreditDemoWalletWaitQueue: (state, action) => {
      return {
        ...state,
        creditDemoWalletWaitQueue: [action.payload, ...state.creditDemoWalletWaitQueue]
      }
    },
    setShowName: (state, action) => {
      return {
        ...state,
        showName: !state.showName
      }
    }, 
    setUserInfo: (state, action) => {
      const currencyId = state.currencyId
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          wallet: {
            ...action.payload,
            currencyId
          }
        }
      }
    },
    setDemoMode: (state, action) => {
      return {
        ...state,
        demoMode: action.payload,
        currencyCode: state.demoWallet.currency
      }
    },
    setDemoWalletCurrency: (state, action) => ({
      ...state,
      currencyCode: action.payload.currencyCode,
      currencyId: action.payload?.currencyId,
      currencySymbol: CURRENCY_SYMBOLS?.[action.payload.currencyCode] || '$',
      demoWallet: { ...state.demoWallet, currency: action.payload.currencyCode },
      operatorId: action.payload?.operatorId
    }),
    updateDemoWalletBalance: (state, action) => {
      return {
        ...state,
        demoWallet: { ...state.demoWallet, balance: action.payload }
      }
    },
    updateDemoWalletBalanceForBetPlace: (state, action) => {
      const newBalance = (action.payload.operation === 'add') ? state.demoWallet.balance + Number(action.payload.amount) : state.demoWallet.balance - Number(action.payload.amount)

      return {
        ...state,
        demoWallet: { ...state.demoWallet, balance: newBalance }
      }
    },
    debitBalance: (state, action) => {
      const { balance: currentBalance } = { ...state.userInfo.wallet }
      const _userInfoWallet = { ...state.userInfo.wallet, balance: minus(currentBalance, +action?.payload) }
      let { balance, currency } = _userInfoWallet
      balance = balance > 0 ? balance : 0
      console.log('balance, currency', balance, currency)
      // sendMessageOutsideIframe(IFRAME_MESSAGE_EVENTS.BALANCE_UPDATED, { type: 'debit', balance, currency })

      return ({
        ...state,
        userInfo: {
          ...state.userInfo,
          wallet: _userInfoWallet
        }
      })
    },
    updateUserWallet: (state, action) => ({
      ...state,
      userInfo: {
        ...state.userInfo,
        wallet: action.payload
      }
    })
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.fulfilled, (state, action) => {
        const { user, wallet, accessToken } = action.payload
        const payload = getPayloadFromToken(accessToken)
        const currencyId = payload?.currencyId
        const currencyCode = payload?.currencyCode
        return {
          ...state,
          currencyId,
          currencyCode,
          userInfo: {
            user,
            wallet: {
              ...wallet,
              currencyId,
              currencyCode
            }
          },
          isLoggedIn: true
        }
      })
      .addCase(fetchUserInformation.fulfilled, (state, action) => {
        return {
          ...state,
          userDetails: action.payload
        }
      })
      .addCase(gameClose.fulfilled, (state, action) => {
        return defaultAuthState
      })
  }
})

export const {
  setUserInfo, appendCreditWalletWaitQueue,
  updateCreditWalletWaitQueue, setShowName, appendCreditDemoWalletWaitQueue, updateCreditDemoWalletWaitQueue, updatePlinkoCreditWalletWaitQueue, debitBalance, updateUserWallet, setDemoMode, updateDemoWalletBalance, updateDemoWalletBalanceForBetPlace, setDemoWalletCurrency
} = authSlice.actions

export default authSlice.reducer
